import React from "react";

const NailSalonInMeadowsCustomer = () => {
  return (
    <div className="hairSalonInMeadowsCustomer">
      <h5>
        What Our Clients Say About Us: Testimonials from Satisfied Clients
      </h5>
      <p>
        We are proud to be known as the most trusted Nail Salon in Meadows
        Whitefield, and our clients' feedback speaks for itself:
      </p>
      <p>Here are some of the reviews that make us proud:</p>
      <div className="hairSalonInMeadowsCustomerContent">
        <p>
          <span className="quote">“</span>Scent Salon is my favorite nail salon!
          The atmosphere is so relaxing, and the staff is incredibly
          professional. My nails always look perfect, and I love the variety of
          colors and designs they offer. I wouldn’t go anywhere else!
          <span className="quote">”</span> - <span>Anita K. </span>
        </p>
        <p>
          <span className="quote">“</span>I had an amazing experience at Scent
          Salon. The team is so welcoming, and they really take the time to make
          sure you’re happy with your nails. The best Nail Salon in Meadows
          Whitefield without a doubt!
          <span className="quote">”</span> - <span>Rina P . </span>
        </p>
      </div>
    </div>
  );
};

export default NailSalonInMeadowsCustomer;
